import { useState } from 'react';

interface Props { label: string; onApply: (items: string[]) => void; disabled: boolean }

export function GoogleProposalPaste({ label, onApply, disabled }: Props) {
  const [text, setText] = useState('');
  const [open, setOpen] = useState(false);
  function apply() {
    const items = text.split(/\r?\n/).map(line => line.replace(/^\s*(?:[-*•]|\d+[.)])\s+/, '').trim()).filter(Boolean);
    onApply(items);
    setOpen(false);
    setText('');
  }
  return <div className="google-proposal-paste">
    <button type="button" className="google-proposal-secondary" disabled={disabled}
      onClick={() => setOpen(!open)}>Colar lista de {label.toLowerCase()}</button>
    {open && <>
      <label>Uma entrada por linha. Aplicar substitui esta lista na edição.
        <textarea aria-label={`Lista de ${label.toLowerCase()}`} rows={5} value={text}
          disabled={disabled} onChange={event => setText(event.target.value)} />
      </label>
      <button type="button" className="google-proposal-secondary" disabled={disabled || !text.trim()}
        onClick={apply}>Aplicar lista na edição</button>
    </>}
  </div>;
}
